import { useEffect, useState } from 'react';
import logo from '../../assets/logo.png';
import seoulBg from '../../assets/seoul_bg.png';
import styles from './SplashScreen.module.css';

export default function SplashScreen({ onComplete }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // 2.5초 후 페이드 아웃 시작, 3초 후 완료
    const timer = setTimeout(() => setFadeOut(true), 2500);
    const completeTimer = setTimeout(onComplete, 3000);

    return () => {
      clearTimeout(timer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`${styles.container} ${fadeOut ? styles.fadeOut : ''}`}>
      <div className={styles.backgroundLayer}>
        <img src={seoulBg} alt="Seoul Map" className={styles.bgImage} />
      </div>
      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="Ansim IN Seoul Logo" className={styles.logo} />
        </div>
        <div className={styles.textWrapper}>
          <h1 className={styles.title}>안심IN서울</h1>
          <p className={styles.slogan}>Everywhere in Seoul, by your side</p>
        </div>
      </div>
      <div className={styles.footer}>
        <div className="spinner" style={{ width: 20, height: 20, borderTopColor: 'white' }} />
      </div>
    </div>
  );
}
